<div class="fullscreen-container">
    <div *ngIf="isLoading" class="idle-page-container">
        <gux-page-loading-spinner></gux-page-loading-spinner>
        <gux-loading-message>
            <div slot="primary-message">The content is loading...</div>
            <div slot="additional-guidance">Thank you for waiting.</div>
        </gux-loading-message>
    </div>
    <div *ngIf="!isLoading" [style]="backgroundColorStyle" class="fullscreen-container">
        <div style="margin-bottom: 5px;" *ngIf="!isStitchIn">
            <img *ngIf="bannerWarning; else normalBanner" src="../../assets/img/UMA-dialer-problem-header-red.jpg"
                alt="Warning Banner" style="width: 100%; display: block; margin: 0; padding: 0;">
            <ng-template #normalBanner>
                <img src="../../assets/img/UMA-dialer-header.jpg" alt="Normal Banner"
                    style="width: 100%; display: block; margin: 0; padding: 0;">
            </ng-template>
        </div>
        <div style="margin-bottom: 5px;" *ngIf="isStitchIn">
            <img *ngIf="bannerWarning; else normalStitchInBanner" src="../../assets/img/UMA-stitchin-problem-header.jpg"
                alt="Stitch In Warning Banner" style="width: 100%; display: block; margin: 0; padding: 0;">
            <ng-template #normalStitchInBanner>
                <img src="../../assets/img/UMA-stitchin-header.jpg" alt="Stitch In Normal Banner"
                    style="width: 100%; display: block; margin: 0; padding: 0;">
            </ng-template>
        </div>

        <div class="top-bar">
            <div class="top-bar-item">
                <gux-icon size="large" icon-name="toolbar-phone-active-3" decorative="true"></gux-icon>
                Call Status: {{callStatus}}
            </div>

            <gux-tag emphasis="bold" accent="inherit" size="large" class="other-color"
                *ngIf="displayDialCountDownTimer">
                Countdown: {{dialCountDownTimer}}
            </gux-tag>
            <gux-tag emphasis="bold" accent="inherit" size="large" class="other-color"
                *ngIf="dispositionTimerStarted">
                Disposition Countdown: {{autoDispositionLimit! - dispositionTimer!}}
            </gux-tag>

            <div class="top-bar-item">
                Call Type: {{callType}}
            </div>
        </div>
        <div class="call-button-container">
            <gux-button accent="{{buttonType}}" class="call-button"
                [disabled]="DialDisabled"
                (click)="dispositionDial()" (keypress)="dispositionDial()">
                <gux-icon icon-name="fa/phone-arrow-up-right-regular" decorative></gux-icon>
                <span>Dial</span>
            </gux-button>
            <gux-button accent="danger" class="call-button"
                [disabled]="!(callStatus === 'connected' || callStatus === 'dialing' || callStatus === 'contacting')"
                (click)="disconnect()" (keypress)="disconnect()">
                <gux-icon icon-name="fa/phone-hangup-regular" decorative></gux-icon>
                <span>Disconnect</span>
            </gux-button>

            <gux-button accent="danger" class="call-button"
                [disabled]="!(callStatus === 'terminated' || callStatus === 'disconnected' || callStatus === 'transferred')"
                (click)="dnc()" (keypress)="dnc()">
                <gux-icon icon-name="fa/phone-slash-regular" decorative></gux-icon>
                <span>DNC</span>
            </gux-button>
        </div>

        <app-student-info-block [studentData]="studentData"
            [displayOtherInfo]=displayOtherInfo [otherInfoMsg]="otherInfoMsg"
            [displayPartner]="displayPartner" [partnerTextColor]="partnerTextColor"
            [partnerLeadDisplayName]="partnerLeadDisplayName" [iDashURL]="iDashURL"
            [studentIdMinTime]="studentIdMinTime" [showStudentId]="showStudentId" [callDuration]="callTimer"
            [isStitchIn]="isStitchIn"></app-student-info-block>


        <div *ngIf="!isStitchIn" class="consent-box"[ngClass]="{
    'consent-row-red': isConsentConfirmed === null || isConsentConfirmed === false,
    'consent-row-green': isConsentConfirmed === true
}">
            <div class="consent-box-item" >
                Consent Confirmed?
                <input type="radio" id="true" name="consent" [value]="true" [(ngModel)]="isConsentConfirmed"
                    (checked)="isConsentConfirmed" (click)="consentConfirmedSelected(true)"
                    (keypress)="consentConfirmedSelected(true)"
                    [disabled]="callStatus !== 'disconnected' && callStatus !== 'terminated' && callStatus !== 'transferred' || consentDisabled">
                <label for="yes">Yes</label>
                <input type="radio" id="false" name="consent" [value]="false" [(ngModel)]="isConsentConfirmed"
                    (checked)="!isConsentConfirmed" (click)="consentConfirmedSelected(false)"
                    (keypress)="consentConfirmedSelected(false)"
                    [disabled]="callStatus !== 'disconnected' && callStatus !== 'terminated' && callStatus !== 'transferred' || consentDisabled">
                <label for="no">No</label>
            </div>

            <div class="consent-box-item" *ngIf="PSTEnabled && showPST">
                {{PSTLabel}}
                <gux-button accent="{{buttonType}}" class="PST-button" (click)="SMSClicked()" (keypress)="SMSClicked()"
                    [disabled]="PSTSMSDisabled" *ngIf="PSTSMSAllowed">
                    <gux-icon [attr.icon-name]="SMSIcon" decorative></gux-icon>
                    <span>SMS</span>
                </gux-button>

                <gux-button accent="{{buttonType}}" class="PST-button" (click)="emailClicked()"
                    (keypress)="emailClicked()" [disabled]="PSTEmailDisabled" *ngIf="PSTEmailAllowed"
                    [title]="studentData.email">
                    <gux-icon [attr.icon-name]="emailIcon" decorative></gux-icon>
                    <span>Email</span>
                </gux-button>
            </div>
        </div>

        <div *ngIf="!isStitchIn" class="disposition-button-container">
            <div class="disposition-button-group">
                <b>Valid Lead</b>
                <ng-container *ngFor="let option of validLeadOptions" style="margin-top: 10px;">
                    <span>
                        <input type="radio" [id]="option.id" [value]="option" [(ngModel)]="selectedDispositionOption"
                            [disabled]="validDispositionDisabled(option)" (click)="validOptionSelected(option)"
                            (keypress)="validOptionSelected(option)">
                        <label [title]="htmlToText(option.description)" [for]="option.id" style="margin-left: 5px">
                            {{option.value}}</label>
                    </span>
                </ng-container>
            </div>

            <div class="disposition-button-group">
                <b>Unverified Lead</b>
                <ng-container *ngFor="let option of unverifiedLeadOptions" style="margin-top: 10px;">
                    <span>
                        <input type="radio" [id]="option.id" [value]="option" [(ngModel)]="selectedDispositionOption"
                            [disabled]="!(callStatus === 'disconnected' || callStatus === 'terminated' || callStatus === 'transferred')"
                            (click)="invalidOptionSelected(option)" (keypress)="invalidOptionSelected(option)">
                        <label [title]="htmlToText(option.description)" [for]="option.id" style="margin-left: 5px">
                            {{option.value}}</label>
                    </span>
                </ng-container>
            </div>
        </div>
        <div class="spacer"></div>

        <gux-button *ngIf="!isStitchIn" accent="{{buttonType}}" class="call-button"
            [disabled]="!selectedDispositionOption || isAutoDisposition || (isConsentConfirmed == null && !initialConsent)"
            (click)="submit()" (keypress)="submit()">

            <span>Submit Lead</span>
        </gux-button>

        <gux-button *ngIf="isStitchIn" accent="{{buttonType}}" class="call-button"
            [disabled]="!(callStatus === 'disconnected' || callStatus === 'terminated' || callStatus === 'transferred')"
            (click)="close()" (keypress)="close()">
            <span>Close</span>
        </gux-button>
        <div class="disposition-footer">
            <div class="disposition-footer-left">
                <span *ngIf="emailConversationId && conversationId">{{emailConversationId}} |
                    {{conversationId}}</span>
                <span *ngIf="!emailConversationId && conversationId">{{conversationId}}</span>
                <span *ngIf="emailConversationId && !conversationId">{{emailConversationId}}</span> |
                <span><gux-icon icon-name="clock" decorative="true"></gux-icon> {{ callTimer | timeFormat }}</span> |
            </div>
            <div class="disposition-footer-right">
                <span><gux-icon icon-name="calendar" decorative="true"></gux-icon> {{ today }}</span>
            </div>
        </div>
    </div>
</div>